// Согласие с куки живёт в рамках сессии: на других сайтах проекта
// (goodmix, «Родные просторы») баннер устроен так же.
const KEY = 'cookieBannerClosed';

export const isCookieConsentGiven = () => Boolean(sessionStorage.getItem(KEY));

export const setCookieConsent = () => sessionStorage.setItem(KEY, '1');
